import { OptionType } from 'components';

export enum ReasonForWorkStop {
    AccidentTravail = 'AT',
    AllocationMaterniteRisquesParticuliers = 'AMRP',
    AllocationMaterniteTravailNuit = 'AMTN',
    Maladie = 'MAL',
    MaladieProfessionnelle = 'MP',
    Maternite = 'MAT',
    Paternite = 'PAT',
    AutreCas = 'AC',
    ChomageTotalOuPartiel = 'CTP',
    CongesPayes = 'CP',
    FermetureEtablissement = 'FE',
    NouvelleEmbauche = 'NE',
    JourneeAppelDefense = 'JAD',
    TempsPartielTherapeutique = 'TPT',
    AbsenceAutorisee = 'AA',
}

export const optionReasonForWorkStop: OptionType[] = [
    { value: ReasonForWorkStop.AccidentTravail, label: 'Accident du travail' },
    { value: ReasonForWorkStop.AllocationMaterniteRisquesParticuliers, label: 'Allocation maternité / Risques particuliers' },
    { value: ReasonForWorkStop.AllocationMaterniteTravailNuit, label: 'Allocation maternité / Travail de nuit' },
    { value: ReasonForWorkStop.Maladie, label: 'Maladie' },
    { value: ReasonForWorkStop.MaladieProfessionnelle, label: 'Maladie professionnelle' },
    { value: ReasonForWorkStop.Maternite, label: 'Maternité' },
    { value: ReasonForWorkStop.Paternite, label: 'Paternité' },
    { value: ReasonForWorkStop.AutreCas, label: 'Autre cas' },
    { value: ReasonForWorkStop.ChomageTotalOuPartiel, label: 'Chômage total ou partiel' },
    { value: ReasonForWorkStop.CongesPayes, label: 'Congés payés' },
    { value: ReasonForWorkStop.FermetureEtablissement, label: 'Fermeture de l’établissement' },
    { value: ReasonForWorkStop.NouvelleEmbauche, label: 'Nouvelle embauche' },
    { value: ReasonForWorkStop.JourneeAppelDefense, label: 'Journée d’appel à la défense' },
    { value: ReasonForWorkStop.TempsPartielTherapeutique, label: 'Temps partiel thérapeutique' },
    { value: ReasonForWorkStop.AbsenceAutorisee, label: 'Absence autorisée' },
];

export const motifArretDeclaration = [
    ReasonForWorkStop.AccidentTravail,
    ReasonForWorkStop.AllocationMaterniteRisquesParticuliers,
    ReasonForWorkStop.AllocationMaterniteTravailNuit,
    ReasonForWorkStop.Maladie,
    ReasonForWorkStop.MaladieProfessionnelle,
    ReasonForWorkStop.Maternite,
    ReasonForWorkStop.Paternite,
];
